<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import util from '@/libs/util';
export default {
  name: 'app',
  watch: {
    '$i18n.locale': 'i18nHandle'
  },
  created() {
    this.i18nHandle(this.$i18n.locale);
  },
  methods: {
    i18nHandle(val, oldVal) {
      util.cookies.set('lang', val);
      document.querySelector('html').setAttribute('lang', val);
    }
  }
};
</script>

<style lang="scss">
@import '~@/assets/style/public-class.scss';

.el-tooltip__popper.is-dark {
  width: 24px !important;
  padding: 12px !important;
}
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  height: 8px;
  width: 6px;
  background: #0000007f;
  transition: all 0.3s ease-in-out;
  border-radius: 99px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  background-color: #fff;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  width: 6px;
  min-height: 15px;
  background: rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease-in-out;
  border-radius: 99px;
}

.el-tabs__header {
  margin: 6px 0px 16px 0px !important;
}
.el-dialog__footer {
  margin-bottom: 12px !important;
}
.el-message {
  min-width: 120px !important;
}
.el-tag--mini {
  height: 30px !important;
  padding: 5px 10px !important;
  line-height: 18px !important;
}
.el-step__head.is-success {
  color: #03c449 !important;
  border-color: #03c449 !important;
}
.el-step__title.is-success {
  color: #03c449 !important;
  font-weight: regular;
}

.el-step__description.is-success {
  color: #03c449 !important;
}
.el-table th > .cell {
  width: auto !important;
}
.el-table td,
.el-table th {
  padding: 0 !important;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/App.vue"
}
</vue-filename-injector>
